export const environment = {
  production: false,
  apiBaseUrl: 'https://api.stage.bikaji.distiz.com/api',
  apiversion: 1.0,
  reportApiBaseUrl: 'https://localhost:7147/api'
};